<main class="not-found on-ink relative overflow-hidden" data-testid="not-found">
  <inpla-ink-dot-field mode="notfound" />
  <div class="not-found__fade absolute" aria-hidden="true"></div>
  <section class="not-found__copy absolute flex flex-column justify-content-center">
    <p class="not-found__code">{{ 'shell.notFound.code' | translate }}</p>
    <h1 class="not-found__title">
      <span class="not-found__context block">{{ 'shell.notFound.titleContext' | translate }}</span>
      <span class="block">{{ 'shell.notFound.title' | translate }}</span>
    </h1>
    <p class="not-found__body">{{ 'shell.notFound.body' | translate }}</p>
    <div class="flex gap-3">
      <button type="button" class="not-found__home" data-testid="notfound-home-link" (click)="goHome()">
        {{ 'shell.notFound.goHome' | translate }}
      </button>
    </div>
    <p class="not-found__path" data-testid="notfound-path">{{ attemptedPath }}</p>
  </section>
</main>
